import SidebarContainer from './sidebar_container';

const Sidebar = SidebarContainer;

export default Sidebar;
